<template>
  <ValidationObserver ref="disabled">
    <div>
      <h2 class="mb-5">
        Do you have any physical or mental conditions or illnesses?
      </h2>
    </div>
    <ValidationProvider v-slot="{ errors }" name="disabled" rules="required">
      <RadioButton
        :errorMessages="showValidationErrors ? errors : ''"
        v-model="disabled"
        @select="val => (disabled = val)"
        :options="options"
        mixed
        :selectedValue="disabled"
      />
    </ValidationProvider>

    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        {{ isEditMode ? "Save Changes" : submitTitle }}
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import RadioButton from "@/components/common/RadioButton";
import { BOOLEAN_OPTIONS } from "@/constants/workers";
import {
  includePreferNotSayOption,
  getFormattedValue
} from "@/views/profile/QuestionsAndAnswers/steps/Diversity/utils";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "Disability",
  components: {
    PrimaryButton,
    RadioButton,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    isLoading: Boolean,
    isEditMode: Boolean,
    submitTitle: String,
    userDiversityTraits: Object
  },
  data() {
    return {
      options: includePreferNotSayOption(BOOLEAN_OPTIONS),
      disabled: this.userDiversityTraits.disabled,
      showValidationErrors: false
    };
  },
  methods: {
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.disabled.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: {
            disabled: getFormattedValue(this.disabled)
          },
          dataType: "divirsityTraits"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
